export const config = {
  bg_main: {
    x: 0,
    y: 0,
    scale: 1,
  },
  bg_fs: {
    x: 0,
    y: 0,
    scale: 1,
  },
  bg_fp: {
    x: 0,
    y: 0,
    scale: 1,
  },
}
